// import React from "react";

export const LoadingComponent = () => {
  return (
    <div className="flex justify-center items-center content-center h-screen bg-black">
     <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-orange-500"></div>
    </div>
  );
};
